import CartItemsProvider from './context/CartItemsContext';
import SelectedGarmentProvider from './context/SelectedGarmentContext';
import GarmentsHorizontalScrollProvider from './context/GarmentsHorizontalScrollContext';
import SelectedGarmentSizeProvider from './context/SelectedGarmentSizeContext';
import Index from './components/Stylist';
import UploadLookProvider from './context/UploadLookContext';
import './index.css';
import FiltersProvider from './context/FiltersContext';

function App() {
  return (
    <CartItemsProvider>
      <SelectedGarmentProvider>
        <SelectedGarmentSizeProvider>
          <GarmentsHorizontalScrollProvider>
            <UploadLookProvider>
              <FiltersProvider>
                <Index />
              </FiltersProvider>
            </UploadLookProvider>
          </GarmentsHorizontalScrollProvider>
        </SelectedGarmentSizeProvider>
      </SelectedGarmentProvider>
    </CartItemsProvider>
  );
}

export default App;
